export default __webpack_public_path__ + "images/1401d7bfb18ebdf2b42ad274aedca121.png";